import { Card, Divider, Stack, Title } from "@mantine/core";
import React from "react";
import { ReportChaptersTree } from "../../../../components/ReportChapterTree/ReportChapterTree";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { thunkEksempelKapittelToggled } from "./eksempelrapportThunks";

export const EksempelKapitler: React.FC = () => {
  const dispatch = useAppDispatch();
  const edited = useAppSelector((s) => s.reportReducer.editedData[101]);
  if (!edited) return null;

  return (
    <Card withBorder radius="md" p="md">
      <Stack gap="md">
        <Title order={5}>Kapitler</Title>
        <Divider />

        <ReportChaptersTree
          titleNode="Kapitler"
          chapters={edited.kapitler}
          onToggle={(chapterId, next) => dispatch(thunkEksempelKapittelToggled(chapterId, next))}
          toggleDescendantsOnParentToggle={false}
          renderLabel={(n) => <span>{n.text ?? n.title}</span>}
          hideEmptyChildren
        />
      </Stack>
    </Card>
  );
};
